<script>
    export let originator;
    export let isValid;

    let maxlength = 16;
    let error;

    const check = (originator) => {
        error = null;
        if (!originator.length) {
            return false;
        }
        if (/^\d+$/.test(originator)) {
            maxlength = 16;
        } else {
            maxlength = 11;
            if (originator.length > 11) {
                error = "το πεδίο πρέπει να περιέχει μέχρι 11 χαρακτήρες";
                return false;
            }
        }
        return true;
    }

    $: {
        isValid = check(originator);
    }
</script>


<input bind:value="{ originator }" type="text" class="form-control" maxlength="{ maxlength }">
{#if error}
    <p>{ error }</p>
{/if}